import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import ProporcionModal from "../../../ProporcionModal";
import { v4 as uuidv4 } from "uuid";
import ImportarLineasModal from "../../../ImportarLineasModal";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import { encode } from "base64-arraybuffer";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import * as XLSX from "xlsx";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function ComprasDirectasCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_COMPRAS = process.env.REACT_APP_URL_COMPRAS;
  const URL_COMPRAS_ACUMULADOS = process.env.REACT_APP_URL_COMPRAS_ACUMULADOS;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_NOTAS_CXP = process.env.REACT_APP_URL_NOTAS_CXP;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [mailTo, setMailTo] = useState("");


  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [fecha, setFecha] = useState(hoy);
  const [factura, setFactura] = useState("NA");
  const [observaciones, setObservaciones] = useState("NA");
  const [totalCaptura, setTotalCaptura] = useState(1);
  const [total_cantidad, setTotalCantidad] = useState(0);
  const [total_general, setTotalGeneral] = useState(0);
  const [tipoCambio, setTipoCambio] = useState(19);
  // Moneda de captura de los precios. tipoCambio siempre es USD->MXN; si la
  // compra es en CNY se pide ademas cuantos CNY vale un USD. Todo se guarda en
  // USD (precio) y pesos (precioMX), y se conserva el precio capturado.
  const [moneda, setMoneda] = useState("USD");
  const [tipoCambioCNY, setTipoCambioCNY] = useState(7.2);
  const aUSD = (p) => {
    const v = parseFloat(p) || 0;
    if (moneda === "CNY") return parseFloat(tipoCambioCNY) > 0 ? v / parseFloat(tipoCambioCNY) : 0;
    if (moneda === "MXN") return parseFloat(tipoCambio) > 0 ? v / parseFloat(tipoCambio) : 0;
    return v;
  };
  const aMX = (p) => (moneda === "MXN" ? (parseFloat(p) || 0) : aUSD(p) * (parseFloat(tipoCambio) || 0));
  const redondea = (v) => Math.round(v * 10000) / 10000;
  const [articulos, setArticulos] = useState([]);
  const [areas, setAreas] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  // Empresa que compra: cada articulo pertenece a una empresa y solo se ofrecen
  // los de la empresa elegida.
  const [empresas, setEmpresas] = useState([]);
  const [selectedEmpresa, setSelectedEmpresa] = useState("");
  const [selectedProveedor, setSelectedProveedor] = useState("");
  const [selectedArea, setSelectedArea] = useState("");
  const [reciboDeposito, setReciboDeposito] = useState("NA");

  const classes = useStyles();
  // Reja de captura por color y talla + proporcion por color
  const [modalProp, setModalProp] = useState(false);
  const [modalLayout, setModalLayout] = useState(false);
  const [propFieldId, setPropFieldId] = useState(null);
  const [propColor, setPropColor] = useState(null);
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      colores: "",
      tallas: "",
      articulos: "",
      articulosName: "",
      cantidad: 0,
      piezasPorCaja: 0,
      cajas: 0,
      precio: 0,
      precioMX: 0,
      tipoCambio: 0,
      total:0,
    },
  ]);
  const [coloresCat, setColoresCat] = useState([]);
  const [tallasCat, setTallasCat] = useState([]);

  const [validaBoton, setValidaBoton] = useState(true);


  useEffect(() => {
    axios
      .get(process.env.REACT_APP_URL_COLORES, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => setColoresCat(res.data.filter((a) => a.is_active === "Si")))
      .catch((err) => console.log(err));
    axios
      .get(process.env.REACT_APP_URL_TALLAS, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => setTallasCat(res.data.filter((a) => a.is_active === "Si")))
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
   
    axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allAreas = res.data;
        setAreas(allAreas);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(URL_PROVEEDORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allProveedores = res.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(process.env.REACT_APP_URL_EMPRESAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        setEmpresas((res.data || []).filter((e) => e.is_active !== "No"));
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useMemo(() => {
    // if(selectedProveedor != ""){
    axios
    .get(`${URL_ARTICULOS}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((res) => {
      const allArticulos = res.data;
      setArticulos(allArticulos);
    })
    .catch((err) => {
      console.log(err);
    });
  // }
  }, [selectedProveedor]);

  const saveCompraNueva = async (event) => {
    event.preventDefault();
    if (fecha != "" && observaciones != "" && selectedArea != "" && selectedProveedor != "") {
      if (!hayEmpresa) {
        Swal.fire({ icon: "warning", title: "Falta la empresa", text: "Elige la empresa que compra." });
        return;
      }
      const ajeno = inputFields.find((f) => f.articulos && !articulos.some((a) => String(a._id) === String(f.articulos) && esDeEmpresa(a)));
      if (ajeno) {
        Swal.fire({ icon: "error", title: "Articulo de otra empresa", text: "Hay un articulo que no pertenece a la empresa elegida. Quitalo o cambia la empresa." });
        return;
      }
      setValidaBoton(false);
      toggleProgreso();

      // Una entrada de inventario y una compra acumulada por cada celda con cantidad
      const celdas = [];
      inputFields.forEach((f) => {
        if (!f.articulos) return;
        (f.tc || []).forEach((c) => {
          if (parseFloat(c.cantidad) > 0) {
            celdas.push({ articulos: f.articulos, colores: c.colores, tallas: c.tallas,
                          cantidad: parseFloat(c.cantidad), precio: f.precio });
          }
        });
      });
      if (celdas.length === 0) {
        setValidaBoton(true);
        toggleProgreso();
        Swal.fire({ icon: "warning", title: "Sin cantidades", text: "Captura al menos una cantidad en la reja de color y talla." });
        return;
      }
      let totalArticulos = celdas.length + celdas.length;
      try {
        await axios
          .post(
            URL_COMPRAS,
            {
              fecha,
              factura,
              observaciones,
              total_cantidad,
              user: user.id,
              areas: selectedArea,
              tipoCambio,
              empresas: selectedEmpresa,
              moneda,
              tipoCambioCNY: moneda === "CNY" ? parseFloat(tipoCambioCNY) || 0 : 0,
              reciboDeposito,
              fotoEvidencia:"No"
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((data) => {

            axios
            .post(
              `${URL_NOTAS_CXP}`,
              {
                proveedores: selectedProveedor,
                total_cantidad,
                total_costo: redondea(aUSD(total_general)),
                saldo: redondea(aUSD(total_general)),
                calidad:"No",
                fecha,
                compras: data.data._id,
                compraDirecta:"Si"
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem(
                    "app_token"
                  )}`,
                },
              }
            )

            celdas.map((a) => {
              if (a.articulos != "" && a.cantidad != 0) {
                axios
                  .patch(
                    `${URL_INVENTARIOS}Compra`,
                    {
                      articulos: a.articulos,
                      colores: a.colores,
                      tallas: a.tallas,
                      cantidad: parseFloat(a.cantidad),
                      areas: selectedArea,
                      precioMX: redondea(aMX(a.precio)),
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  )
                  .then(() => {
                    totalArticulos = totalArticulos - 1;
                    if (totalArticulos == 0) {
                      axios
                        .post(
                          URL_LOGS,
                          {
                            tipo: "Crear Compra Directa",
                            detalle: `Proveedor: ${selectedProveedor}`,
                            user: user.id,
                          },
                          {
                            headers: {
                              Authorization: `Bearer: ${localStorage.getItem(
                                "app_token"
                              )}`,
                            },
                          }
                        )
                        .then(() => {
                          Swal.fire("Good job!", "Creado con exito", "success");
                          setTimeout(() => {
                            window.location.reload();
                          }, 1000);
                        })
                        .catch((error) => {
                          Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: "Something went wrong!",
                            footer: `${error.response.data}`,
                          });
                          console.log(error);
                          setValidaBoton(true);
                        });
                    }
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                      footer: `${error.response.data}`,
                    });
                    console.log(error);
                    setValidaBoton(true);
                  });
              } else {
                totalArticulos = totalArticulos - 1;
                if (totalArticulos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Crear Compra Directa",
                        detalle: `Proveedor: ${selectedProveedor}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )
                    .then(() => {
                      Swal.fire("Good job!", "Creado con exito", "success");
                      setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              }
            });
            // Termina primer map
    
            // Termina segundo map
            celdas.map((w) => {
              axios
                .post(
                  `${URL_COMPRAS_ACUMULADOS}`,
                  {
                    fecha,
                    cantidad: parseFloat(w.cantidad),
                    compras: data.data._id,
                    articulos: w.articulos,
                    colores: w.colores,
                    tallas: w.tallas,
                    areas: selectedArea,
                    precio: redondea(aUSD(w.precio)),
                    tipoCambio: tipoCambio,
                    precioMX: redondea(aMX(w.precio)),
                    moneda,
                    precioMoneda: parseFloat(w.precio) || 0,
                    fecha
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {
                  totalArticulos = totalArticulos - 1;
                  if (totalArticulos == 0) {
                    axios
                      .post(
                        URL_LOGS,
                        {
                          tipo: "Crear Compra Directa",
                          detalle: `Proveedor: ${selectedProveedor}`,
                          user: user.id,
                        },
                        {
                          headers: {
                            Authorization: `Bearer: ${localStorage.getItem(
                              "app_token"
                            )}`,
                          },
                        }
                      )
                      .then(() => {

                        Swal.fire("Good job!", "Creado con exito", "success");
                        setTimeout(() => {
                          window.location.reload();
                        }, 1000);
                      })
                      .catch((error) => {
                        Swal.fire({
                          icon: "error",
                          title: "Oops...",
                          text: "Something went wrong!",
                          footer: `${error.response.data}`,
                        });
                        console.log(error);
                        setValidaBoton(true);
                      });
                  }
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                  setValidaBoton(true);
                });
            });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
            setValidaBoton(true);
          });
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
        setValidaBoton(true);
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `Faltan Datos`,
      });
    }
  };

  function BuscaArticulo(id, selectedArticulo) {

    articulos.map((a) => {
      if (a._id == selectedArticulo._id) {

        let idArticulo = a._id;
         // El FOB del catalogo esta en USD; se precarga en la moneda elegida
         let FOB = a.costoUSD || 0;
         if (moneda === "CNY") FOB = redondea(FOB * (parseFloat(tipoCambioCNY) || 0));
         if (moneda === "MXN") FOB = redondea(FOB * (parseFloat(tipoCambio) || 0));
         let pzas = a.piezasPorCaja
        handleChangeInputArticulo(id, idArticulo, FOB, pzas, a.colores, a.tallas);
      }
    });
  }

  const handleChangeInputArticulo = (id, idArticulo, FOB, pzas, coloresArt, tallasArt) => {
    // Reja: un renglon por color, una celda por talla. Si el modelo declara sus
    // colores y tallas se acota a esos; si no, se usa el catalogo completo.
    // Si el articulo trae sus colores/tallas como ids sin poblar, se resuelven
    // contra el catalogo; si no trae ninguno, se usa el catalogo completo.
    const resuelve = (lista, catalogo) => {
      if (!lista || !lista.length) return catalogo;
      return lista.map((x) => (x && x.name) ? x : catalogo.find((c) => String(c._id) === String(x && x._id ? x._id : x))).filter(Boolean);
    };
    const cols = resuelve(coloresArt, coloresCat);
    const tals = resuelve(tallasArt, tallasCat);
    const tc = [];
    cols.forEach((c) => { tals.forEach((t) => { tc.push({ colores: c._id, tallas: t._id, cantidad: 0 }); }); });
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        i.piezasPorCaja = pzas;
        i.total = 0;
        i.precio = FOB;
        i.cantidad = 0;
        i.cajas = 0;
        i.arrayColores = cols;
        i.arrayTallas = tals;
        i.tc = tc;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales(newInputFields);
  };

  function recalculaRenglon(lista, id) {
    return lista.map((i) => {
      if (i.id !== id) return i;
      const suma = (i.tc || []).reduce((s, c) => s + (parseFloat(c.cantidad) || 0), 0);
      return { ...i, cantidad: suma,
        cajas: i.piezasPorCaja > 0 ? (suma / i.piezasPorCaja).toFixed(2) : 0,
        total: suma * (parseFloat(i.precio) || 0) };
    });
  }

  function cambiaCelda(idFila, idColor, idTalla, valor) {
    setInputFields((prev) => {
      const conCelda = prev.map((i) => i.id !== idFila ? i : {
        ...i,
        tc: i.tc.map((c) => (c.colores === idColor && c.tallas === idTalla
          ? { ...c, cantidad: valor === "" ? "" : parseFloat(valor) || 0 } : c)),
      });
      const fresca = recalculaRenglon(conCelda, idFila);
      ActualizaTotales(fresca);
      return fresca;
    });
  }


  // Alta de color/talla desde el modal de proporcion: se suma al catalogo, a la
  // reja del renglon en turno y se abren sus celdas para que aplicaProporcion
  // las encuentre.
  function nuevoColorDesdeModal(c) {
    setColoresCat((prev) => (prev.some((x) => String(x._id) === String(c._id)) ? prev : [...prev, c]));
    setInputFields((prev) => prev.map((i) => {
      if (i.id !== propFieldId) return i;
      if ((i.arrayColores || []).some((x) => String(x._id) === String(c._id))) return i;
      const tallas = i.arrayTallas || [];
      const celdas = tallas.map((t) => ({ colores: c._id, tallas: t._id, cantidad: 0 }));
      return { ...i, arrayColores: [...(i.arrayColores || []), c], tc: [...(i.tc || []), ...celdas] };
    }));
  }

  function nuevaTallaDesdeModal(t) {
    setTallasCat((prev) => (prev.some((x) => String(x._id) === String(t._id)) ? prev : [...prev, t]));
    setInputFields((prev) => prev.map((i) => {
      if (i.id !== propFieldId) return i;
      if ((i.arrayTallas || []).some((x) => String(x._id) === String(t._id))) return i;
      const colores = i.arrayColores || [];
      const celdas = colores.map((c) => ({ colores: c._id, tallas: t._id, cantidad: 0 }));
      return { ...i, arrayTallas: [...(i.arrayTallas || []), t], tc: [...(i.tc || []), ...celdas] };
    }));
  }

  // Proporcion del modelo completo: total + proporcion de colores + de tallas,
  // como en el layout (antes era color por color).
  function abreProporcion(idFila) {
    setPropColor(null);
    setPropFieldId(idFila);
    setModalProp(true);
  }

  function aplicaProporcion(lineas) {
    setInputFields((prev) => {
      const conCeldas = prev.map((i) => {
        if (i.id !== propFieldId) return i;
        const tc = i.tc.map((c) => {
          const l = lineas.find((x) => x.colores === c.colores && x.tallas === c.tallas);
          // el reparto es del modelo completo: lo que no salio en el reparto queda en 0
          return l ? { ...c, cantidad: l.cantidad } : (propColor ? c : { ...c, cantidad: 0 });
        });
        return { ...i, tc };
      });
      const fresca = recalculaRenglon(conCeldas, propFieldId);
      ActualizaTotales(fresca);
      return fresca;
    });
  }


  const handleChangeInputCantidad = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = parseFloat(event.target.value);
        i.cajas = (parseFloat(event.target.value) / i.piezasPorCaja).toFixed(2);
        let totalParcial = parseFloat(event.target.value) * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputPrecio = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = parseFloat(event.target.value);
        let totalParcial = parseFloat(event.target.value) * i.cantidad;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales(newInputFields);
  };

  const handleChangeInputCaja = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = parseFloat(event.target.value);
        i.cantidad = parseFloat(event.target.value) * parseFloat(i.piezasPorCaja);
        i.total = (parseFloat(event.target.value) * parseFloat(i.piezasPorCaja) * parseFloat(i.precio)).toFixed(2);
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  // Recibe la lista fresca; leer el estado la deja un cambio atras.
  function ActualizaTotales(lista) {
    const fuente = lista || inputFields;
    let cant = fuente.map((c) => parseFloat(c.cantidad) || 0);
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TC);

    let importes = fuente.map((c) => parseFloat(c.total) || 0);
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setTotalGeneral(TG);
  }

  const handleAddFields = () => {
    setInputFields([
      ...inputFields,
      {
      id: uuidv4(),
      colores: "",
      tallas: "",
      articulos: "",
      articulosName: "",
      cantidad: 0,
      piezasPorCaja: 0,
      cajas: 0,
      precio: 0,
      precioMX: 0,
      tipoCambio: 0,
      total:0,
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);

    let cant = values.map((c) => parseFloat(c.cantidad));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TC);

    let importes = values.map((c) => parseFloat(c.total));
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setTotalGeneral(TG);
  };

  const hayEmpresa = selectedEmpresa && selectedEmpresa !== "0";
  // Solo se ofrecen los modelos de la empresa elegida; sin empresa no hay opciones.
  const esDeEmpresa = (a) => hayEmpresa && String(a.empresas?.[0]?._id || a.empresas?.[0] || "") === String(selectedEmpresa);
  function cambiaEmpresa(idEmpresa) {
    setSelectedEmpresa(idEmpresa);
    // Los renglones capturados eran de otra empresa: se reinicia la captura
    setInputFields([{ id: uuidv4(), colores: "", tallas: "", articulos: "", articulosName: "", cantidad: 0, piezasPorCaja: 0, cajas: 0, precio: 0, precioMX: 0, tipoCambio: 0, total: 0 }]);
    setTotalCantidad(0); setTotalGeneral(0);
  }
  const options = articulos.filter(esDeEmpresa).map((option) => {
    const junta = option.codigo + option.nombre;
    const firstLetter = option.codigo?.[0]?.toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });


//     function importarArchivo(event){
//    const target = event.target;
//    const value = target.type === "checkbox" ? target.checked : target.value;
//    const name = target.name;
//    let hojas = [];
  
//    if (name === "file") {
 
//      let reader = new FileReader();
//        reader.readAsArrayBuffer(target.files[0]);
//        reader.onloadend = (e) => {
//          var data = new Uint8Array(e.target.result);
//          var workbook = XLSX.read(data, { type: "array" });
 
//          workbook.SheetNames.forEach(function (sheetName) {
//            // Here is your object
//            var XL_row_object = XLSX.utils.sheet_to_json(
//              workbook.Sheets[sheetName]
//            );
//            hojas.push({
//              data: XL_row_object,
//              sheetName,
//            });
//          });
 
//          let A1 = hojas[0].data
 
//          let TC = totalCaptura
//          A1.map((a)=>{
//             TC = TC + 1
//            setTotalCaptura(TC)
//          inputFields.push({
//            id: uuidv4(),
//            articulos: a.IdArticulo,
//           articulosName: a.Articulo,
//           cantidad: a.Cantidad,
//           piezasPorCaja: 0,
//           cajas: 0,
//           precio: 0,
//           precioMX: 0,
//           tipoCambio: 0,
//           total:0,
//          })
//          })
 
//          ActualizaTotales()
//        }
//    }
//  }
//  console.log("hola", inputFields)


  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_compras ? (
        <div className="card container col-10">
          <h3 align="center">Nueva Entrada</h3>
          <Form onSubmit={saveCompraNueva}>
            <Row>
            
              <Col md={2}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha}
                  required
                  onChange={(e) => {
                    setFecha(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Proveedor</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedProveedor}
                  required
                  onChange={(e) => {
                    setSelectedProveedor(e.target.value)
                    setInputFields([
                      {
                        id: uuidv4(),
                        colores: "",
                        tallas: "",
                        articulos: "",
                        articulosName: "",
                        cantidad: 0,
                        piezasPorCaja: 0,
                        cajas: 0,
                        precio: 0,
                        precioMX: 0,
                        tipoCambio: 0,
                        total:0,
                      },
                    ]);
                  }}
                >
                  <option value="">Selecciona</option>
                  {proveedores
                    .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
                    .map((a) => {
                        return <option value={a._id}>{a.nombre_comercial}</option>;
                    })}
                </Input>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Empresa</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedEmpresa}
                  required
                  onChange={(e) => cambiaEmpresa(e.target.value)}
                >
                  <option value="0">Selecciona</option>
                  {empresas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => <option key={a._id} value={a._id}>{a.name}</option>)}
                </Input>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Almacen</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedArea}
                  required
                  onChange={(e) => {
                    setSelectedArea(e.target.value);
                  }}
                >
                  <option value="0">Selecciona</option>
                  {areas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      // if (a._id == AREAS_MATRIZ || a._id == AREAS_BODEGA) {
                        return <option value={a._id}>{a.name}</option>;
                      // }
                    })}
                </Input>
              </Col>
              <Col md={1}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Moneda
                </Label>
                <Input type="select" value={moneda} onChange={(e) => setMoneda(e.target.value)}>
                  <option value="USD">USD</option>
                  <option value="CNY">CNY</option>
                  <option value="MXN">MXN</option>
                </Input>
              </Col>
              {moneda === "CNY" ? (
                <Col md={1}>
                  <Label for="exampleEmail" className="mr-sm-2">
                    TC CNY→USD
                  </Label>
                  <Input
                    type="number"
                    min="0"
                    step="any"
                    title="Cuantos CNY vale un USD"
                    value={tipoCambioCNY}
                    required
                    onChange={(e) => setTipoCambioCNY(e.target.value)}
                  />
                </Col>
              ) : null}
              <Col md={1}>
                <Label for="exampleEmail" className="mr-sm-2">
                  TC USD→MXN
                </Label>
                <Input
                  type="number"
                  placeholder="TipoCambio"
                  value={tipoCambio}
                  required
                  onChange={(e) => {
                    setTipoCambio(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={2}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Factura
                </Label>
                <Input
                  type="text"
                  placeholder="Factura"
                  value={factura}
                  required
                  onChange={(e) => {
                    setFactura(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label>Recibo Deposito</Label>
                <Input
                  type="text"
                  placeholder="Recibo Deposito"
                  value={reciboDeposito}
                  required
                  onChange={(e) => {
                    setReciboDeposito(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <h4 id="logoutBoton">
                  TOTALES{" "}
                  {new Intl.NumberFormat("en-US").format(total_cantidad)} pzas. /{" "}
                  {"$" + new Intl.NumberFormat("en-US").format(total_general)} {moneda}
                  {moneda !== "USD" ? (
                    <small style={{ color: "#6b7280" }}>
                      {" "}≈ ${new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(aUSD(total_general))} USD
                    </small>
                  ) : null}
                  {moneda !== "MXN" ? (
                    <small style={{ color: "#6b7280" }}>
                      {" "}≈ ${new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(aMX(total_general))} MXN
                    </small>
                  ) : null}
                </h4>
              </Col>
            </Row>

            {/* <Row>
            <Col md={3}>
            <Label>Selecciona</Label>
              <Input
                required
                type="file"
                name="file"
                id="file"
                onChange={(event) => importarArchivo(event)}
              />
            </Col>
            </Row>  */}

            {/* Tabla Articulos */}

            <Row>
              <Col md={12}>
                <Button
                  size="sm"
                  className="btn btn-info"
                  title="Capturar los renglones desde un layout de Excel"
                  disabled={!hayEmpresa}
                  onClick={() => setModalLayout(true)}
                >
                  Subir layout de renglones
                </Button>
                {!hayEmpresa ? (
                  <small style={{ color: "#6b7280", marginLeft: 8 }}>Elige primero la empresa.</small>
                ) : null}
              </Col>
            </Row>
            <br />

            <Row>
              <Col md={3}>
                <Label className="mr-sm-2">Modelo</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Cajas</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Pzas por Caja</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Cantidad</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Precio {moneda}</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Total</Label>
              </Col>
            </Row>

            {inputFields.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  <Col md={3}>
                  <Autocomplete
                      size="small"
                      value={inputField.articulosNombre}
                      onChange={(event, selectedArticulo) => {
                        BuscaArticulo(inputField.id, selectedArticulo);
                      }}
                      options={options.sort(
                        (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                      )}
                      groupBy={(option) => option.firstLetter}
                      getOptionLabel={(option) => option.junta}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={hayEmpresa ? "Selecciona" : "Elige primero la empresa"}
                          variant="outlined"
                        />
                      )}
                      renderOption={(option) => (
                        <React.Fragment>
                          {option.codigo} {option.nombre}
                        </React.Fragment>
                      )}
                    />
                  </Col>


                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="cajas"
                      type="number"
                      min="0"
                      step="any"
                      value={inputField.cajas}
                      title="Se calcula a partir de la reja de color y talla"
                      disabled
                    />
                  </Col>

                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="piezasPorCaja"
                      type="string"
                      value={inputField.piezasPorCaja}
                      disabled
                    />
                  </Col>

                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="cantidad"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Cantidad"
                      value={inputField.cantidad}
                      title="Se calcula a partir de la reja de color y talla"
                      disabled
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="precio"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Precio"
                      value={inputField.precio}
                      onChange={(event) =>
                        handleChangeInputPrecio(inputField.id, event)
                      }
                    />
                  </Col>

                  <Col md={2}>
                    <Input
                      // bsSize="sm"
                      name="total"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Total"
                      value={inputField.total}
                      disabled
                    />
                  </Col>
                  <Col>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={inputFields.length === 1}
                      onClick={() => handleRemoveFields(inputField.id)}
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFields}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </Col>
                </Row>

                {/* Reja de captura: un renglon por color, una celda por talla */}
                {(inputField.arrayColores || []).length > 0 ? (
                  <div style={{ margin: "4px 0 14px 0", padding: "8px 10px", background: "#f8fafc", borderRadius: 8, border: "1px solid #e2e8f0" }}>
                    <div style={{ display: "flex", gap: 6, alignItems: "flex-end", marginBottom: 4 }}>
                      <div style={{ width: 166 }}>
                        <Button size="sm" color="primary" style={{ padding: "2px 8px", fontSize: "0.72rem" }}
                          title="Repartir un total entre los colores y tallas del modelo con su proporcion (ej. 2-1-1 y 1-2-2-1)"
                          onClick={() => abreProporcion(inputField.id)}>
                          <i className="fas fa-percent" /> Proporción
                        </Button>
                      </div>
                      {(inputField.arrayTallas || []).map((t) => (
                        <div key={t._id} style={{ width: 62, textAlign: "center", fontSize: "0.68rem", fontWeight: 700, color: "#64748b" }}>
                          {t.name}
                        </div>
                      ))}
                      <div style={{ width: 70, textAlign: "center", fontSize: "0.68rem", fontWeight: 700, color: "#64748b" }}>TOTAL</div>
                    </div>
                    {(inputField.arrayColores || []).map((col) => {
                      const celdas = (inputField.tc || []).filter((c) => c.colores === col._id);
                      const sumaColor = celdas.reduce((s, c) => s + (parseFloat(c.cantidad) || 0), 0);
                      return (
                        <div key={col._id} style={{ display: "flex", gap: 6, alignItems: "center", marginBottom: 4 }}>
                          <div style={{ width: 110, fontSize: "0.78rem", fontWeight: 600 }}>
                            {col.name}
                          </div>
                          <div style={{ width: 50 }} />
                          {(inputField.arrayTallas || []).map((t) => {
                            const celda = celdas.find((c) => c.tallas === t._id);
                            return (
                              <div key={t._id} style={{ width: 62 }}>
                                <Input bsSize="sm" type="number" min="0" style={{ textAlign: "right", padding: "2px 4px" }}
                                  value={celda ? celda.cantidad : 0}
                                  onChange={(e) => cambiaCelda(inputField.id, col._id, t._id, e.target.value)} />
                              </div>
                            );
                          })}
                          <div style={{ width: 70, textAlign: "right", fontSize: "0.8rem", fontWeight: 700 }}>
                            {new Intl.NumberFormat("es-MX").format(sumaColor)}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : null}
              </div>
            ))}

            <ProporcionModal
              abierto={modalProp}
              cerrar={() => setModalProp(false)}
              coloresCat={(() => {
                const f = inputFields.find((x) => x.id === propFieldId);
                const cols = (f && f.arrayColores) || coloresCat;
                return propColor ? cols.filter((c) => c._id === propColor) : cols;
              })()}
              tallasCat={(() => {
                const f = inputFields.find((x) => x.id === propFieldId);
                return (f && f.arrayTallas) || tallasCat;
              })()}
              onAplicar={aplicaProporcion}
            onNuevoColor={nuevoColorDesdeModal}
            onNuevaTalla={nuevaTallaDesdeModal}
            catalogoColores={coloresCat}
            catalogoTallas={tallasCat}
              marcarTodos
              titulo="Proporcion del modelo por color y talla"
            />
            <Row>
              <Col md={12}>
                <h4 id="logoutBoton">
                  TOTALES{" "}
                  {new Intl.NumberFormat("en-US").format(total_cantidad)} pzas. /{" "}
                  {"$" + new Intl.NumberFormat("en-US").format(total_general)} {moneda}
                  {moneda !== "USD" ? (
                    <small style={{ color: "#6b7280" }}>
                      {" "}≈ ${new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(aUSD(total_general))} USD
                    </small>
                  ) : null}
                  {moneda !== "MXN" ? (
                    <small style={{ color: "#6b7280" }}>
                      {" "}≈ ${new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(aMX(total_general))} MXN
                    </small>
                  ) : null}
                </h4>
              </Col>
            </Row>
            {/* Termina Tabla Articulos */}

            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <Button
              href="/ListadoCompras"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Form>
          <br />
          <ImportarLineasModal
            abierto={modalLayout}
            cerrar={() => setModalLayout(false)}
            articulos={articulos.filter(esDeEmpresa)}
            coloresCat={coloresCat}
            tallasCat={tallasCat}
            moneda={moneda}
            precioPorDefecto={(a) => {
              // El FOB del catalogo esta en USD; se pasa a la moneda elegida
              let FOB = a.costoUSD || 0;
              if (moneda === "CNY") FOB = redondea(FOB * (parseFloat(tipoCambioCNY) || 0));
              if (moneda === "MXN") FOB = redondea(FOB * (parseFloat(tipoCambio) || 0));
              return FOB;
            }}
            onCargado={(fields) => {
              setInputFields(fields);
              ActualizaTotales(fields);
            }}
          />
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default ComprasDirectasCreate;
